import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '@salesforce/design-system-react';

import { default as Actions } from '../ecs/actions';

export const FlagContext = React.createContext({ readOnly: false });

export const withFlags = (componentFunc, transformFlags) => {
  const transform = flags => (transformFlags ? transformFlags(flags) : flags);
  return (
    <FlagContext.Consumer>
      {flags => componentFunc(transform(flags))}
    </FlagContext.Consumer>
  );
};

class FlagsProvider extends Component {
  componentDidMount() {
    this.props.actions.getFlags();
  }

  render() {
    const { isLoading } = this.props.flags;
    const content = (
      <FlagContext.Provider value={this.props.flags.flags}>
        <React.Fragment>{this.props.children}</React.Fragment>
      </FlagContext.Provider>
    );
    const spinner = (
      <div className="pi-common-spinner">
        <Spinner variant="brand" />
      </div>
    );

    return isLoading ? spinner : content;
  }
}

FlagsProvider.propTypes = {
  actions: PropTypes.shape({
    getFlags: PropTypes.func.isRequired
  }).isRequired
};

function mapStateToProps(state) {
  return {
    flags: state.ecs.flags
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlagsProvider);
